import { TableRows, ViewHeadline, ViewStream } from '@mui/icons-material'
import { Button, ListItemIcon, Menu, MenuItem } from '@mui/material'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { updateGridSize } from '../../store/slice/dataGridSlice'

const RowSizeButton = () => {
  const [anchorEl, setAnchorEl] = useState(null)

  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  
  const handleClose = () => {
    setAnchorEl(null)
  }

  const dispatch = useDispatch()
  const handleChange = (value) => {
    dispatch(updateGridSize(value))
    handleClose()
  }

  return (
    <div style={{display: 'inline-block'}}>
      <Button startIcon={<TableRows />} onClick={handleClick} size="small">
        Size
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={() => handleChange('compact')}>
          <ListItemIcon>
            <ViewHeadline fontSize="small" />
          </ListItemIcon>
          Small
        </MenuItem>

        <MenuItem onClick={() => handleChange('standard')}>
          <ListItemIcon>
            <TableRows fontSize="small" />
          </ListItemIcon>
          Medium
        </MenuItem>
        <MenuItem onClick={() => handleChange('comfortable')}>
          <ListItemIcon>
            <ViewStream fontSize="small" />
          </ListItemIcon>
          Large
        </MenuItem>
      </Menu>
    </div>
  )
}

export default RowSizeButton
